<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  created() {
    this.bInstance && this.bInstance.init();
  },
  beforeDestroy() {
    this.bInstance && this.bInstance.destroy();
  },
};
</script>
